export interface MediaStreamConnection {
    readonly stream: MediaStream;

    lookupReceiver(track: MediaStreamTrack): RTCRtpReceiver | undefined;
}

export type ConnectParams = {
    audio?: boolean;
}

export interface MediaStreamConnector {
    connect(params: ConnectParams): Promise<MediaStreamConnection>;
    disconnect(): Promise<void>;
}

export function hasUnderlying(x: MediaStreamConnector): x is MediaStreamConnector & { underlying: MediaStreamConnector } {
    return 'underlying' in x;
}

export interface RecordableConnector {
    enableRecording(enabled: boolean): Promise<void>;
}

export function getRecordableConnector(x: MediaStreamConnector): RecordableConnector | undefined {
    if ('enableRecording' in x) return x as unknown as RecordableConnector;
    if (hasUnderlying(x)) return getRecordableConnector(x.underlying);
    return undefined;
}

export interface StatsReportableConnector {
    getStats(selector?: MediaStreamTrack): Promise<RTCStatsReport | undefined>;
}

export function getStatsReportable(x: MediaStreamConnector): StatsReportableConnector | undefined {
    if ('getStats' in x) return x as unknown as StatsReportableConnector;
    if (hasUnderlying(x)) return getStatsReportable(x.underlying);
    return undefined;
}
